import { render, staticRenderFns } from "./BankLegend.vue?vue&type=template&id=71802ee3&scoped=true"
import script from "./BankLegend.vue?vue&type=script&lang=js"
export * from "./BankLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71802ee3",
  null
  
)

export default component.exports